<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    :fill="color"
    viewBox="0 0 16.811 7.825"
  >
    <path
      id="Caminho_11999"
      data-name="Caminho 11999"
      d="M13.654,8.406a2.437,2.437,0,0,1-.718,1.734L6.428,16.708a.35.35,0,0,1-.5-.493l6.509-6.57a1.752,1.752,0,0,0,0-2.478L5.93.6A.35.35,0,0,1,6.428.1l6.509,6.57a2.435,2.435,0,0,1,.717,1.732Z"
      transform="translate(16.811 -5.829) rotate(90)"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 16.811,
    },
    height: {
      type: Number,
      default: 7.825,
    },
    color: {
      type: String,
      default: "#000",
    },
  },
};
</script>
